export const RESET_CLAIMS_DATATABLE = 'RESET_CLAIMS_DATATABLE';
export const SET_CURRENT_CLAIMS_PAGE = 'SET_CURRENT_CLAIMS_PAGE';
export const SET_NUMBER_OF_CLAIMS_TO_SHOW_PER_PAGE = 'SET_NUMBER_OF_CLAIMS_TO_SHOW_PER_PAGE';